<template>
  <Transition name="slide-up">
    <!-- 备案号固定展示在页面底部，不再受 Cookie 同意状态控制。 -->
    <div class="cookie-banner cookie-banner-mobile">
      <div class="cookie-content">
        <!-- 使用新窗口打开工信部官网，并阻断新窗口反向访问当前页面。 -->
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          class="filing-link"
        >
          渝ICP备2024044486号
        </a>
      </div>
    </div>
  </Transition>
</template>

<style lang="less" scoped>
.cookie-banner-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(180deg, #1a2734 0%, rgba(75, 80, 230, 0.95) 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  padding: 20px 16px;
  box-sizing: border-box;
  max-height: 85vh;
  overflow-y: auto;

  .cookie-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
  }

  .filing-link {
    max-width: 100%;
    color: #00ffe0;
    font-size: 13px;
    line-height: 1.5;
    text-align: center;
    text-decoration: underline;
    overflow-wrap: anywhere;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:active {
      opacity: 0.7;
    }
  }
}

// 动画效果
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

// 滚动条样式
.cookie-banner-mobile::-webkit-scrollbar {
  width: 4px;
}

.cookie-banner-mobile::-webkit-scrollbar-thumb {
  background: rgba(0, 255, 224, 0.3);
  border-radius: 2px;
}

.cookie-banner-mobile::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
</style>
